import React, { useEffect } from 'react'
import { ApplyPcContent, ErrorPopup, Footer, ServiceList, SuccessPopup, TermsPopup } from '../../common'
import {
  ApplicationHeader,
  BizNoField,
  BizNoTypeField,
  ConfirmPasswordField,
  ContactManagerEmailField,
  ContactManagerNameField,
  FranchiseeNameField,
  IdField,
  OwnerNameField,
  OwnerPhoneNoField,
  PasswordField,
  ShopNameField,
  SubmitWrap,
  TermsWrap,
  UiSignature
} from './local-components/ApplicationComponents'
import useApplicationForm from './useApplicationForm'
import '../../../assets/styles/spge-f-application.scss'
import { BusinessRegistrationFile } from './local-components/BusinessRegistrationFile'
import { SimpleSuccessPopup } from '../../common/SimpleSuccessPopup'
import { bizNumFormat, bizNumFormat14Digit } from '../../tools'

const CustomerWrap = props => (
  <div className="customer_wrap">
    <p className="wrap_tit">
      프랜차이즈 정보<span className="color_r">*</span>
    </p>
    <BizNoField {...props} placeholder="사업자 등록번호 10자리를 입력해주세요." />
    <FranchiseeNameField {...props} />

    <OwnerNameField {...props} placeholder="대표자명을 입력해주세요" />
    <BusinessRegistrationFile {...props} />
  </div>
)

const ContactInfo = props => {
  return (
    <div>
      <p
        style={{
          fontSize: '20px',
          fontWeight: '700',
          marginBottom: '28px',
          marginLeft: '24px',
          marginTop: '28px'
        }}>
        담당자 정보 <span className="color_r">*</span>
      </p>
      <div className="contact_info">
        <IdField {...props} label="아이디" placeholder="5~15자리를 입력해주세요." />
        <PasswordField {...props} label="비밀번호" placeholder="비밀번호 영문, 숫자, 특수문자 5~20자리를 입력해주세요." />
        <ConfirmPasswordField {...props} label="비밀번호 확인" placeholder="비밀번호를 다시 입력해주세요." />
        <ContactManagerNameField {...props} label="담당자" placeholder="담당자명을 입력해주세요." />
        <OwnerPhoneNoField {...props} label="담당자 휴대폰" placeholder="신청자 휴대폰번호를 입력해주세요." />
        <ContactManagerEmailField {...props} label="담당자 이메일" placeholder="신청자 이메일 주소를 입력해주세요." />
        <div className="terms_sign">
          <UiSignature {...props} />
          <div className="p_t_10 explain_text">{props.differentCustomerHelper}</div>
        </div>
      </div>
    </div>
  )
}

const ApplicationSpongeF = () => {
  const isSpgeF = true
  const af = useApplicationForm({ isSpgeF })
  const {
    location,
    param,
    formRef,
    different_customer_sign_ref,
    different_account_sign_ref,
    managerName,
    serviceNum,
    setServiceNum,
    setServiceInfo,
    serviceHelper,
    setServiceHelper,
    cost,
    setCost,
    successPopupState,
    errorPopupState,
    setErrorPopupState,
    errorPopupMessage,
    btnState,
    serviceStartDt,
    setServiceStartDt,
    withdrawalDt,
    setWithdrawalDt,
    shopId,
    shopPassword,
    shopConfirmPassword,
    reSignup,

    selectList,
    differentCustomerIsSigned,
    setDifferentCustomerIsSigned,
    differentCustomerHelper,
    setDifferentCustomerHelper,
    differentAccountIsSigned,
    setDifferentAccountIsSigned,
    differentAccountHelper,
    setDifferentAccountHelper,
    register,
    handleSubmit,
    bizNoTrue,
    freeMonthYn,
    bizNoHelper,
    bizNo,
    isBiznoValid,
    getApplyBizNoValid,
    onChangeBizNo,
    onSubmit,
    ownerNameSetting,
    ownerPhoneNoSetting,
    accountNameSetting,
    idSetting,
    passwordSetting,
    confirmPassword,
    diffApplyCustomerCheck,
    differentApplyCustomerCheck,
    differentAccountCheck,
    termsPopupOpen,
    termsPopupClose,
    errors
  } = af

  useEffect(() => {
    if (typeof window !== 'undefined' && formRef?.current) {
      const sp = new URLSearchParams(location.search)
      const v = sp.get('bizNo')
      if (v) {
        const biz_no = formRef.current.querySelector('#biz_no')
        if (biz_no) {
          biz_no.value = bizNumFormat14Digit(v)
          formRef.current.querySelector('#biz_no_btn').click()
          biz_no.focus()
        }
      }
    }
  }, [formRef])

  return (
    <div className={'Application SubPages'}>
      <div className={'application_wrap ' + isSpgeF ? 'spge-f-application' : ''}>
        <ApplyPcContent /> {/* 1024 이상 display */}
        <div className={successPopupState || errorPopupState ? 'application_sheet notScroll' : 'application_sheet 2'} ref={formRef}>
          <ApplicationHeader {...af} location={location} managerName={managerName} />
          <form className="application_form_wrap" onSubmit={handleSubmit(onSubmit)}>
            <CustomerWrap {...af} />
            <ContactInfo {...af} />
            <TermsWrap
              {...af}
              different_customer_sign_ref={different_customer_sign_ref}
              different_account_sign_ref={different_account_sign_ref}
              differentCustomerIsSigned={differentCustomerIsSigned}
              setDifferentCustomerIsSigned={setDifferentCustomerIsSigned}
              differentCustomerHelper={differentCustomerHelper}
              setDifferentCustomerHelper={setDifferentCustomerHelper}
              differentAccountIsSigned={differentAccountIsSigned}
              setDifferentAccountIsSigned={setDifferentAccountIsSigned}
              differentAccountHelper={differentAccountHelper}
              setDifferentAccountHelper={setDifferentAccountHelper}
              register={register}
              diffApplyCustomerCheck={diffApplyCustomerCheck}
              differentApplyCustomerCheck={differentApplyCustomerCheck}
              differentAccountCheck={differentAccountCheck}
              termsPopupOpen={termsPopupOpen}
              errors={errors}
            />

            <SubmitWrap {...af} btnState={btnState} serviceStartDt={serviceStartDt} withdrawalDt={withdrawalDt} />
          </form>

          {/* 푸터내용 */}
          <Footer />

          {/* 약관 성공 팝업 TODO 캡쳐 파라미터 미사용, 삭제해야함 */}
          <TermsPopup termsPopupClose={termsPopupClose} capture={false} />

          {/* 신청 성공 팝업 */}
          {/* <SuccessPopup {...af} open={successPopupState} cost={cost} serviceStartDt={serviceStartDt} withdrawalDt={withdrawalDt} /> */}
          <SimpleSuccessPopup open={successPopupState}>
            서비스 신청이 <br /> 완료되었습니다!
          </SimpleSuccessPopup>
          {/* 신청 오류 팝업 */}
          <ErrorPopup open={errorPopupState} setErrorPopupState={setErrorPopupState} errorPopupMessage={errorPopupMessage} />
        </div>
      </div>
    </div>
  )
}

export { ApplicationSpongeF }
